import { render, staticRenderFns } from "./page004.vue?vue&type=template&id=64ffc964&scoped=true&"
import script from "./page004.vue?vue&type=script&lang=js&"
export * from "./page004.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ffc964",
  null
  
)

export default component.exports